import { cn } from "@/libs/utils/tailwind/cn";
import { NetworxService } from "../../../../hooks/queries/useNetworxServices";
import { prependCdnResourcesUrl } from "@/utils/network";

export default function CategoryCard({ service }: CategoryCardProps) {
  return (
    <a
      href={service.pathname}
      className={cn(
        "group relative flex flex-col items-center justify-start gap-2 p-1 sm:p-6 rounded-xl cursor-pointer overflow-hidden",
        "!text-default-800",
        "hover:no-underline hover:bg-default-100",
        "h-fit",
      )}
    >
      <div className="relative z-10 flex flex-col items-center gap-1 sm:gap-3">
        {/* Icon Container */}
        <div className="flex items-center justify-center w-16 h-16">
          <img
            src={prependCdnResourcesUrl(`/svg/services/${service.icon}.svg`)}
            alt=""
            aria-hidden
            className="w-10 h-10 sm:w-14 sm:h-14 object-contain"
          />
        </div>

        {/* Service Name */}
        <span className="text-center text-sm sm:text-xs lg:text-lg leading-4 sm:leading-tight">
          {service.display_name}
        </span>
      </div>
    </a>
  );
}

interface CategoryCardProps {
  service: NetworxService;
}
